import { Route } from '@angular/router';
import { AreaEditComponent } from 'src/app/pages/datasets/area-edit/area-edit.component';
import { AreasComponent } from 'src/app/pages/datasets/areas/areas.component';
import { categories } from './categories';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const areas: Route = {
  path: 'areas',
  title: 'nav.datasets.areas',
  data: {
    icon: SbIcons.globe,
    breadcrumb: 'nav.datasets.areas',
    id: RoutingID.areas,
  },
  children: [
    {
      path: '',
      component: AreasComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'area-edit/:areaID',
      title: 'nav.datasets.areas.edit',
      data: {
        icon: SbIcons.edit,
        breadcrumb: 'nav.datasets.areas.edit',
        id: RoutingID.areaEdit,
      },
      children: [
        {
          path: '',
          component: AreaEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'area-create',
      title: 'nav.datasets.areas.create',
      data: {
        icon: SbIcons.plus,
        breadcrumb: 'nav.datasets.areas.create',
        id: RoutingID.areaCreate,
      },
      children: [
        {
          path: '',
          component: AreaEditComponent,
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    categories,
  ],
};
